import { createReducer, on } from '@ngrx/store';
import { hydratePackageItems, packageItemUpdated } from './package-item.actions';

const initialState: Record<string, any> = {};

function normalizeNotPackageRows(rows: any[] | null | undefined): any[] {
  if (!rows || rows.length === 0) return [];
  return rows.map((row) => {
    const reasonWrapper =
      row.reason != null
        ? { reason: row.reason, otherReason: row.otherReason }
        : row.productReason ?? row.bundleReason ?? row.offerReason ?? null;
    return {
      quantity: row.quantity,
      reasonId: reasonWrapper?.reason?.id,
      reasonTitleEn: reasonWrapper?.reason?.titleEn,
      reasonTitleAr: reasonWrapper?.reason?.titleAr,
      otherReason: reasonWrapper?.otherReason,
    };
  });
}

function resolvePackagedQuantity(packaged: any): string | number | null {
  if (packaged == null) return null;
  if (Array.isArray(packaged)) {
    const total = packaged.reduce((acc: number, row: any) => acc + (row.quantity || 0), 0);
    return total > 0 ? total : null;
  }
  return packaged.quantity ?? null;
}

function registerPackageEntry(items: Record<string, any>, id: any, packaged: any, notPackaged: any) {
  if (packaged || notPackaged) {
    items[id] = {
      packageQuantity: resolvePackagedQuantity(packaged),
      notPackageRows: normalizeNotPackageRows(notPackaged),
    };
  }
}

function packagingOf(item: any): { packaged: any; notPackaged: any } {
  const source = item?.product ?? item?.bundle ?? item?.offer ?? item?.bxGyOffer;
  const history = item?.packagingHistory;
  const hasHistory = history && (history.packaged !== undefined || history.notPackaged !== undefined);
  if (hasHistory) {
    return { packaged: history.packaged ?? null, notPackaged: history.notPackaged ?? [] };
  }
  return { packaged: item?.package ?? source?.package ?? null, notPackaged: item?.notPackage ?? source?.notPackage ?? [] };
}

const packageItemReducer = createReducer(
  initialState,

  on(hydratePackageItems, (_, { data }) => {
    const items: Record<string, any> = {};

    (data?.items ?? []).forEach((item: any) => {
      if (item.product) {
        const pack = packagingOf(item);
        registerPackageEntry(items, item.id, pack.packaged, pack.notPackaged);
      } else if (item.bundle) {
        const pack = packagingOf(item);
        registerPackageEntry(items, item.id, pack.packaged, pack.notPackaged);

        (item.bundle.products ?? []).forEach((row: any) => {
          const innerPack = packagingOf(row);
          registerPackageEntry(items, `${item.id}_${row.id}`, innerPack.packaged, innerPack.notPackaged);
        });
      } else if (item.offer || item.bxGyOffer) {
        const offer = item.offer ?? item.bxGyOffer;
        const pack = packagingOf(item);
        registerPackageEntry(items, item.id, pack.packaged, pack.notPackaged);

        (offer.products ?? []).forEach((row: any) => {
          const innerPack = packagingOf(row);
          registerPackageEntry(items, `${item.id}_${row.id}`, innerPack.packaged, innerPack.notPackaged);
        });
      }
    });

    return items;
  }),

  on(packageItemUpdated, (state, { itemId, packageQuantity, notPackageRows }) => ({
    ...state,
    [itemId]: {
      packageQuantity,
      notPackageRows,
    },
  })),
);

export { packageItemReducer };